import { useLang } from "@/context/LanguageContext";

export const EditorialMarquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  const Row = () => (
    <div className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center whitespace-nowrap">
          <span className="px-8 font-display text-sm italic tracking-wide text-mutedink md:text-base">
            {item}
          </span>
          <span className="font-mono text-xs text-volt">//</span>
        </span>
      ))}
    </div>
  );
  return (
    <div className="overflow-hidden border-y border-edge bg-paperalt py-5" data-testid="editorial-marquee">
      <div className="marquee-track">
        <Row />
        <Row />
      </div>
    </div>
  );
};
